<template>
  <header 
    :class="[
      'fixed top-0 left-0 right-0 transition-all duration-300',
      shouldShowWhiteHeader ? 'bg-white shadow-lg' : 'bg-transparent'
    ]"
    style="z-index: 9999;"
  >
    <div class="mx-auto max-w-screen-xl px-4 sm:px-6 lg:px-8">
      <div class="flex h-20 items-center justify-between">
        <div class="md:flex md:items-center md:gap-12">
          <router-link to="/" class="logo-link block transition-colors duration-300" :class="shouldShowWhiteHeader ? 'text-primary' : 'text-white'">
            <span class="sr-only">Home</span>
            <span class="text-3xl font-bold font-heading">DIGINOVA</span>
          </router-link>
        </div>

        <div class="flex items-center gap-4">
          <div class="hidden lg:block">
            <nav aria-label="Global" class="flex items-center !gap-2 text-base">
              <router-link to="/" :class="['nav-link relative transition-colors duration-300 hover:text-primary font-bold no-underline hover:no-underline', shouldShowWhiteHeader ? 'text-gray-700' : 'text-white']">
                Home
              </router-link>
              <router-link to="/about" :class="['nav-link relative transition-colors duration-300 hover:text-primary font-bold no-underline hover:no-underline', shouldShowWhiteHeader ? 'text-gray-700' : 'text-white']">
                About
              </router-link>
              <router-link to="/projects" :class="['nav-link relative transition-colors duration-300 hover:text-primary font-bold no-underline hover:no-underline', shouldShowWhiteHeader ? 'text-gray-700' : 'text-white']">
                Projects
              </router-link>
              <router-link to="/services" :class="['nav-link relative transition-colors duration-300 hover:text-primary font-bold no-underline hover:no-underline', shouldShowWhiteHeader ? 'text-gray-700' : 'text-white']">
                Services
              </router-link>
              <router-link to="/contact" :class="['nav-link relative transition-colors duration-300 hover:text-primary font-bold no-underline hover:no-underline', shouldShowWhiteHeader ? 'text-gray-700' : 'text-white']">
                Contact
              </router-link>
            </nav>
          </div>
          <div class="block lg:hidden">
            <button 
              @click="mobileMenuOpen = !mobileMenuOpen" 
              :class="[
                'rounded-sm p-2 transition-colors duration-300 hover:text-primary',
                shouldShowWhiteHeader ? 'bg-gray-100 text-gray-700' : 'bg-white/10 text-white'
              ]"
            >
              <svg xmlns="http://www.w3.org/2000/svg" class="size-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path v-show="!mobileMenuOpen" stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
                <path v-show="mobileMenuOpen" stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <!-- Mobile Menu -->
      <transition
        enter-active-class="transition ease-out duration-200"
        enter-from-class="opacity-0 transform -translate-y-10"
        enter-to-class="opacity-100 transform translate-y-0"
        leave-active-class="transition ease-in duration-150"
        leave-from-class="opacity-100 transform translate-y-0"
        leave-to-class="opacity-0 transform -translate-y-10"
      >
        <div v-show="mobileMenuOpen" class="lg:hidden bg-white border-t border-[#d1d5db] py-4">
          <nav class="space-y-2 px-4">
            <router-link to="/" class="block py-2 text-dark hover:text-primary font-medium transition-colors">Home</router-link>
            <router-link to="/about" class="block py-2 text-dark hover:text-primary font-medium transition-colors">About</router-link>
            <router-link to="/projects" class="block py-2 text-dark hover:text-primary font-medium transition-colors">Projects</router-link>
            <router-link to="/services" class="block py-2 text-dark hover:text-primary font-medium transition-colors">Services</router-link>
            <router-link to="/contact" class="block py-2 text-dark hover:text-primary font-medium transition-colors">Contact</router-link>
          </nav>
        </div>
      </transition>
    </div>

    <!-- ScrollTop Component -->
    <ScrollTop />
  </header>
</template>

<script>
import ScrollTop from '@/components/ScrollTop.vue';

export default {
  name: 'HeaderComponent',
  components: {
    ScrollTop
  },
  data() {
    return {
      mobileMenuOpen: false,
      isScrolled: false
    };
  },
  computed: {
    isHomePage() {
      return this.$route.path === '/';
    },
    shouldShowWhiteHeader() {
      // If not on home page, always show white header
      if (!this.isHomePage) {
        return true;
      }
      // If on home page, show white header only when scrolled
      return this.isScrolled;
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 50;
    }
  }
}
</script>

<style scoped>
.logo-link {
  text-decoration: none !important;
}

.logo-link:hover {
  text-decoration: none !important;
}

.nav-link::after {
  content: '';
  position: absolute;
  bottom: 0px;
  left: 50%;
  transform: translateX(-50%) scale(0);
  width: 6px;
  height: 6px;
  background-color: currentColor;
  border-radius: 50%;
  transition: transform 0.3s ease;
}

.nav-link:hover::after {
  transform: translateX(-50%) scale(1);
}
</style>